/* eslint-disable max-len */
/* eslint-disable no-undef */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';

export default class CopyCitationNotificationEditing extends Plugin {
    init() {
        const editor = this.editor;
        const editingView = editor.editing.view;
        const selection = editor.model.document.selection;
        let triggerCopyCitationNotification = false;

        editingView.document.on('clipboardOutput', () => {
            if (editor.isReadOnly) {
                return;
            }
            const range = selection.getFirstRange();
            for (const item of range.getItems()) {
                if ((item.getAttribute('data-citationcount'))) {
                    triggerCopyCitationNotification = true;
                }
            }
            if (triggerCopyCitationNotification) {
                this.editor.fire("copyCitationNotification");
                triggerCopyCitationNotification = false;
            }
        },
        { priority: 'low' });
    }
}
